import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "auth__form" }
const _hoisted_2 = {
  key: 0,
  class: "info error",
  style: {"text-align":"left"}
}
const _hoisted_3 = {
  key: 1,
  class: "info",
  style: {"text-align":"left"}
}

import { useAccountStore } from '@/stores/account';
import { useDialogStore } from '@/stores/dialogs';
import { parseQuery } from '@/utils/api-utils';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SettingsDialog from '../dialogs/SettingsDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthSocialForm',
  setup(__props) {

const error = ref("")
const accountStore = useAccountStore()
const router = useRouter()
const dialogStore = useDialogStore()

onMounted(async () => {
  const obj = parseQuery(window.location.search)
  if (typeof obj.code !== "string" || typeof obj.state !== "string") {
    error.value = "Invalid link"
    return
  }
  try {
    if (accountStore.status === "authorized") {
      if (route.params.page === 'google') {
        await accountStore.connectGoogleAuth({ code: obj.code, state: obj.state })
      }
      if (route.params.page === 'facebook') {
        await accountStore.connectFacebookAuth({ code: obj.code, state: obj.state })
      }
      router.push("/")
      nextTick(() => {
        dialogStore.open(SettingsDialog)
      })
      return
    } else {
      if (route.params.page === 'google') {
        await accountStore.confirmAuthByGoogle({ code: obj.code, state: obj.state })
      }
      if (route.params.page === 'facebook') {
        await accountStore.confirmAuthByFacebook({ code: obj.code, state: obj.state })
      }
    }
    router.push("/")
  } catch(e: any) {
    error.value = e.body?.message || "Something went wrong"
  }
})

const route = useRoute()
const socialName = computed(() => {
  if (route.params.page === 'google') return 'Google'
  if (route.params.page === 'facebook') return 'Facebook'
  return ''
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "Authentication by " + _toDisplayString(_unref(socialName)), 1),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, "Processing auth..."))
  ]))
}
}

})